var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckMarkWhite = function SvgCheckMarkWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-Sheets-+-Guidlines",
    transform: "translate(-22.000000, -1361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-/-Live-/-Filled-Copy-3",
    transform: "translate(22.000000, 1361.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6,15 C5.7163444,15 5,14.2836556 5,13.4 L5,8.61624407 C5,7.72361712 5.72361712,7 6.61624407,7 L6.71708926,7 C7.60971621,7 8.33333333,7.72361712 8.33333333,8.61624407 L8.333,11.799 L18.4,11.8 C19.2836556,11.8 20,12.5163444 20,13.4 C20,14.2836556 19.2836556,15 18.4,15 L6.6,15 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    transform: "translate(12.500000, 11.000000) rotate(-45.000000) translate(-12.500000, -11.000000) "
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckMarkWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkMarkWhite.636d6e00.svg";
export { ForwardRef as ReactComponent };